//Style
import styles from "../../styles/Form-Inputs.module.css"

//primereact
import { Tree } from "primereact/tree"
import { Skeleton } from "primereact/skeleton"

//Formik
import { useField } from "formik"
import { useState } from "react"

export default function FormikTreeSelect({
  name,
  label,
  isInitialLoad,
  options,
  helpText,
  required,
  disabled,
}) {
  const [field, meta, helpers] = useField(name)
  const [expandedKeys, setExpandedKeys] = useState({})

  function getSelect() {
    if (isInitialLoad) {
      return (
        <Skeleton
          className={meta.touched && meta.error ? "p-invalid block" : "block"}
          height="42px"
        />
      )
    } else {
      return (
        <>
          <Tree
            className={meta.touched && meta.error ? "p-invalid" : undefined}
            value={options}
            selectionMode="checkbox"
            filter
            filterMode="strict"
            selectionKeys={field.value}
            onSelectionChange={(e) => helpers.setValue(e.value)}
            expandedKeys={expandedKeys}
            onToggle={(e) => setExpandedKeys(e.value)}
            style={{ width: "100%" }}
            disabled={disabled}
          />
          {meta.touched && meta.error ? (
            <>
              <label id={`${name}-error`} className={styles.errFieldMsg}>
                {meta.error}
              </label>
              <br />
            </>
          ) : null}
        </>
      )
    }
  }

  return (
    <div className={styles.field}>
      <label>
        {label} {required ? <span style={{ color: "red" }}> * </span> : null}
        {helpText ? (
          <div>
            <small style={{ color: "gray" }}>{helpText}</small>
          </div>
        ) : null}
      </label>
      <div>{getSelect()}</div>
    </div>
  )
}
